import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import "./Modal.css";

export const Modal = (props) => {
  const { identityConfig, isLoading, position } = props;
  const { t } = useTranslation();
  const widgetScreen = localStorage.getItem("widget_screen");


  // code change for One page
  const isRegisterPage = window.location.pathname.includes('register');
  const isWorkEmailCheckOrSignup = widgetScreen === "workemailcheck_onepage" || widgetScreen === "signup";
  const isOnePageOrSignup = widgetScreen === "OnePage" || widgetScreen === "signup";
  if(!isRegisterPage &&  identityConfig.registrationType === "OnePage" && isWorkEmailCheckOrSignup && widgetScreen === "signup"){ 
      window.location.href = window.location.origin + '/register'
      return
  }
  const modalBox = document.getElementById('iiris-modal-box');
  if(modalBox) {
    if(!isRegisterPage &&  widgetScreen && modalBox.style.display === 'none') {
      document.getElementById('iiris-modal-box').style.display = ''
    } 
  }

  const handleClose = () => {
    /**
     * Approach: If the user is on the register page, and the widget screen type is either sign_up or workemailcheck_onepage and the close button is not clicked using the callback method (i.e. from redirectToProfilePage in iiris-identity.js)
     * take the user to the signup_referrer (if it is present), else take him back to the page from which he landed on to the register page using window.history
     * if the history is also not present then redirect him to the home page (i.e. origin)
     */
    let isRedirectedToProfile = sessionStorage.getItem("redirectedToProfile");
    if(isRegisterPage && isWorkEmailCheckOrSignup && !isRedirectedToProfile) {
      let redirectUrl = sessionStorage.getItem('signup_referrer');
      try {
        redirectUrl = new URL(redirectUrl);
      } catch (_) {
        redirectUrl = undefined;
      }
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = window.location.origin;
      }
      sessionStorage.removeItem("redirectedToProfile");
    }
    props.handleClose();
  }

  return (
    <div
      className="iiris-modal-box"
      id="iiris-modal-box"
      style={{
        scrollbarColor: identityConfig.skin.skin_background,
        msScrollbarFaceColor: identityConfig.skin.skin_background,
        msScrollbarHighlightColor: identityConfig.skin.skin_background,
        msScrollbarTrackColor: identityConfig.skin.skin_background,
        position: widgetScreen ==='signin' ? 'fixed':position,
        backgroundColor: (isRegisterPage && widgetScreen === "signup") ? 'transparent' : 'rgb(0 0 0 / 50%)',
      }}
    >

      <div className="iiris-box" 
        style={{
          width: ((isWorkEmailCheckOrSignup && isRegisterPage && !isLoading) || ((widgetScreen === "workemailcheck_onepage" && !isLoading )) ) ? '100%' : 'auto', //width should be 100% if widgetScreen is workemailcheck_onepage even if we are not on the register page
          borderRadius: (isWorkEmailCheckOrSignup && !isLoading) ? 0 : 8 //setting up the border radius to 0 if widget screen is workemailcheck_onepage or signup
        }}>
        <div className="iiris-close-icon-container">
          {props.heading ? (
            <span className="iiris-modal-header">
              <h4>{props.heading}</h4>
            </span>
          ) : (
            ""
          )}
          <span
            className="iiris-close-icon"
            id="iiris-modal-close-btn"
            style={{
              background: identityConfig.skin.skin_background,
              color: "#fff",
            }}
            onClick={handleClose}
          >
            x
          </span>
        </div>
        {props.content}
        <div className="iiris-powered-by">
          {t("powered_by")}&nbsp; <b>IIRIS</b>
        </div>
      </div>
    </div>
  );
};
